import { useEffect, useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { Rating } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAddOrUpdateMarketerRatingMutation } from "../../../features/marketing/marketingApiSlice";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";

const MarketingRatingModel = ({
  setSmShow,
  smShow,
  shopid,
  marketerId,
  publicMarketerId,
  agentMongoId,
  agentName,
}) => {
  const [value, setValue] = useState(0);
  const [comment, setComment] = useState("");
  const [addOrUpdateRating, { isLoading }] =
    useAddOrUpdateMarketerRatingMutation();

  useEffect(() => {
    if (!smShow) {
      setValue(0);
      setComment("");
    }
  }, [smShow]);

  const handleSendFeedback = async () => {
    const ratingTarget = publicMarketerId || marketerId || agentMongoId;
    if (!shopid) {
      FailedNotify("Shop is required to submit feedback.");
      return;
    }
    if (!ratingTarget) {
      FailedNotify("No hired marketer found to rate.");
      return;
    }
    if (!value || value < 1) {
      FailedNotify("Please select a star rating.");
      return;
    }

    try {
      // Always persist Mongo shop _id when available so myShopReview matches later
      const resolvedShopId =
        (typeof shopid === "string" && /^[a-fA-F0-9]{24}$/.test(shopid)
          ? shopid
          : null) ||
        localStorage.getItem("OpenShopIdForMarketingByMarketer") ||
        shopid;

      await addOrUpdateRating({
        marketerId: ratingTarget,
        publicMarketerId: publicMarketerId || ratingTarget,
        agentMongoId: agentMongoId || marketerId,
        cacheQueryId: agentMongoId || marketerId,
        shopid: resolvedShopId,
        rating: value,
        comment: comment.trim(),
      }).unwrap();
      SuccessNotify("Feedback posted successfully");
      setSmShow(false);
    } catch (err) {
      FailedNotify(
        err?.data?.message || "Failed to post feedback. Try again.",
      );
    }
  };

  return (
    <Modal
      size="md"
      show={smShow}
      onHide={() => setSmShow(false)}
      aria-labelledby="marketer-rating-modal"
      className="mt-5 pt-5"
    >
      <div className="row">
        <div className="col-11 text-center pe-0 ">
          <h5 className="ps-3 mt-4 ms-4">
            {agentName ? `Rate ${agentName}` : "Rate Me"}
          </h5>
        </div>
        <div className="col-1 ps-0 mt-2">
          <CancelIcon
            onClick={() => setSmShow(false)}
            style={{ color: "red", cursor: "pointer" }}
          />
        </div>
      </div>

      <div className="col-8 pe-0 ms-auto me-auto d-flex justify-content-center">
        <Rating
          name="marketer-rating"
          value={value}
          onChange={(_, newValue) => setValue(newValue || 0)}
        />
      </div>

      <div className="text-center mb-2">
        <p>{value} out of 5</p>
      </div>
      <Row>
        <Col lg="10" className="ms-auto me-auto p-1">
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Write your feedback here..."
            className="mb-3"
            style={{ borderRadius: "8px" }}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              className="mb-3"
              disabled={isLoading || !value}
              onClick={handleSendFeedback}
            >
              {isLoading ? "Sending..." : "Send feedback"}
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default MarketingRatingModel;
